






















































































































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import {
  ITelefoneModel,
  tiposTelefoneList,
} from "@/models/commons/TelefoneModel";
import { ValidationObserver } from "vee-validate";

@Component
export default class Telefones extends Vue {
  $refs!: {
    telefoneObserver: InstanceType<typeof ValidationObserver>;
  };
  tiposTelefone = tiposTelefoneList;

  private emptyTelefone = {};

  telefone: ITelefoneModel = Object.assign({}, this.emptyTelefone);

  isAlteracao = false;

  @PropSync("telefones")
  telefonesSynced!: ITelefoneModel[];

  telefoneIndex = -1;

  editar(index: number) {
    this.telefoneIndex = index;
    this.telefone = Object.assign({}, this.telefonesSynced[this.telefoneIndex]);
  }
  remover(index: number) {
    this.telefonesSynced.splice(index, 1);
  }

  cancelar() {
    this.telefone = Object.assign({}, this.emptyTelefone);
    this.$refs.telefoneObserver.reset();
    this.telefoneIndex = -1;
  }

  adicionar() {
    if (this.telefoneIndex > -1) {
      this.telefonesSynced.splice(
        this.telefoneIndex,
        1,
        Object.assign({}, this.telefone)
      );
    } else {
      this.telefonesSynced.push(Object.assign({}, this.telefone));
    }
    this.cancelar();
  }
}
